import React from "react";
const InitialsCircle = ({
  fullName = "",
  size = 36,
  type = "user",
  borderRadius = "50%",
}) => {
  const empColor = ["#DA3D09", "#D0213D", "#0062E2", "#784CD5", "#008A29"];
  const empProfileColor = [
    "linear-gradient(135deg, #232526, #414345)",
    "linear-gradient(135deg, #373B44, #4286F4)",
    "linear-gradient(135deg, #141E30, #243B55)",
    "linear-gradient(135deg, #3A1C71, #D76D77, #FFAF7B)",
    "linear-gradient(135deg, #000428, #004E92)",
    "linear-gradient(135deg, #1F1C2C, #928DAB)",
    "linear-gradient(135deg, #2C3E50, #4CA1AF)",
    "linear-gradient(135deg, #4B6CB7, #182848)",
    "linear-gradient(135deg, #283048, #859398)",
  ];
  // const bgColor = empColor[Math.floor(Math.random() * empColor.length)];

  const getColor = (name, colorCode) => {
    if (!name) return colorCode[0];
    const hash = name
      .split("")
      .reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colorCode[hash % colorCode.length];
  };

  const bgColor = getColor(
    fullName,
    type !== "user" ? empProfileColor : empColor,
  );

  const initials = (() => {
    if (!fullName) return "";

    const parts = fullName
      .trim()
      .split(" ")
      .filter((p) => p && p !== ".");

    if (parts.length === 1) {
      return parts[0][0].toUpperCase();
    }
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  })();

  return (
    <div
      style={{
        backgroundColor: bgColor,
        background: bgColor,
        width: size,
        height: size,
        fontSize: size * 0.45,
        color: "#fff",
        fontWeight: 600,
        letterSpacing: "0.03em",
        fontFamily: "DM Sans, sans-serif",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: borderRadius,
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
};

export default InitialsCircle;
